export default {
  methods: {
    featureIsActive(feature) {
      return this.$store.getters.getCurrentUser.active_features.includes(feature);
    },
  },
};
